import { NgClass } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { ActivatedRouteServiceMock } from '@vectronic/util';
import { CardComponent } from '../card/card.component';

@Component({
  selector: 'vectronic-right-sidebar',
  templateUrl: './right-sidebar.component.html',
  styleUrls: ['./right-sidebar.component.scss'],
  imports: [CardComponent, MatButton, NgClass, MatIcon],
  providers: [{ provide: ActivatedRoute, useClass: ActivatedRouteServiceMock }],
})
export class RightSidebarComponent {
  router = inject(Router);

  title = input<string>();

  sidebarToggle = output<boolean>();
  isRightSidebarHidden = signal<boolean>(false);

  toggleRightSidebarVisibility() {
    this.isRightSidebarHidden.set(!this.isRightSidebarHidden());
    this.sidebarToggle.emit(this.isRightSidebarHidden());
  }

  open(isToggle: boolean) {
    this.isRightSidebarHidden.set(isToggle);
    this.sidebarToggle.emit(isToggle);
  }
}
